import React, { useEffect, useMemo, useState } from "react";
import { FromHead, Headline4 } from "ellow-web-ui-components-library";
import Button from '../../components/button'
import Styles from "./styles.module.scss";
import { useForm } from 'react-hook-form';
import { FormInput } from '../../wrappers/formInput';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { nameConversion } from "../../utils/EllowUtils";
import { PhoneInput } from '../../wrappers/phoneInput'
import { viewedpageMixpanel } from "../../utils/mixpanel";
import { DropDownInput } from '../../wrappers/selectInput';
import { getAPI , postAPI } from '../../api/apis';


export type BasicDetailsFormFields = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string | undefined;
  country: any;
  nationality: string;
  linkedIn: string;
  control: any;
  github: string;
  stackoverflow: string;
  city: any;
};

interface Props {
  ClickHandler: (event: React.MouseEvent<HTMLButtonElement>) => void
  Back: (event: React.MouseEvent<HTMLButtonElement>) => void
  defaultValues: any,
  loginId :string
}

const validationSchema = Yup.object({
  firstName: Yup.string()
    .required("Field is required"),
  lastName: Yup.string()
    .required("Field is required"),
  email: Yup.string()
    .required("Field is required")
    .email('Please provide a valid email address'),
  phoneNumber: Yup.string()
    .required("Field is required")
    .matches(/(?!'-'$)(?!'+'$)[0-9]+$/,'Invalid Phone Number')
    .min(7, 'Invalid Phone Number'),
  country: Yup.string()
    .required("Field is required"),
  city: Yup.string()
    .required("Field is required"),
})


const BasicDetails: React.FC<Props> = ({
  ClickHandler,
  Back,
  defaultValues,
  loginId
}) => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const formOptions = {
    resolver: yupResolver(validationSchema), defaultValues: useMemo(() => {
      return defaultValues;
    }, [defaultValues])
  };

  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm<BasicDetailsFormFields>(formOptions);

  useEffect(() => {
    setValue('city', '')
    if (watch().country !== '') {
      getCities(watch().country)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch().country])

  const [countryList, setCountryList] = useState<any>()
  const [cityList, setCityList] = useState<any>();
  const [disable, setDisable] = useState<boolean>(true)

  useEffect(() => {
  
    if (defaultValues) {
      const updatedDefaultValues = {
        ...defaultValues,
        phoneNumber: defaultValues.phoneNumber ? defaultValues.phoneNumber.toString() : '91'
      }
      reset(updatedDefaultValues);
      setValue('country',defaultValues.country)
      setValue('city',defaultValues.city)
    }
    getCountries()

  }, [defaultValues])

 
  useEffect(() => {
    viewedpageMixpanel();
  },[])


  const onSubmitForm = (data: any) => {
    
    let newData:any = {
      // ...data,
      firstName:nameConversion(data.firstName),
      lastName:nameConversion(data.lastName),
      phoneNumber: data.phoneNumber,
      country: data.country,
      city: data.city
    }
    let values: any = { profileMetadata: newData ,
      loginId :loginId,
      candidateStatus:"1"
    }
    ClickHandler(values)
  }

  const getCities = (country: string) => {
    
    let body = { country }
    postAPI('https://countriesnow.space/api/v0.1/countries/cities', body).then((response) => {
      if(country !== undefined){
        setDisable(false)
      }
      setCityList(response.data)
    })
  }

  const getCountries = () => {
    
    let country: any = []
    getAPI('https://countriesnow.space/api/v0.1/countries').then((resp: any) => {
      if (resp.error === false){
        // eslint-disable-next-line array-callback-return
        resp.data && resp.data.map((item: any) => {
          country = [...country, item.country]
        })
      }
      setCountryList(country)
    })
  }

  return (
    <form >
      <Headline4>Personal Details</Headline4>
      <FromHead>Provide your contact details</FromHead>
      <div className="half-form-wrap">
        <div className="form-group">
          <FormInput<BasicDetailsFormFields>
            id="firstName"
            type="text"
            name="firstName"
            label="First Name"
            placeholder="First Name"
            register={register}
            errors={errors}
          />
        </div>
        <div className="form-group">
          <FormInput<BasicDetailsFormFields>
            id="lastName"
            type="text"
            name="lastName"
            label="Last Name"
            placeholder="Last Name"
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="half-form-wrap">
        <div className="form-group">
          <FormInput<BasicDetailsFormFields>
            id="email"
            type="text"
            name="email"
            label="Email"
            placeholder="Email"
            register={register}
            errors={errors}
            disabled={true}
          />
        </div>
        <div className="form-group">
        <PhoneInput<BasicDetailsFormFields>
          id="phone"
          type="text"
          name="phoneNumber"
          label="Phone Number"
          size="medium"
          register={register}
          errors={errors}
          control={control}
        />
     </div>
      </div>
      <div className="half-form-wrap">
        <DropDownInput<BasicDetailsFormFields>
          data={countryList}
          name="country"
          label="Country*"
          control={control}
          register={register}
          errors={errors}
        />
        <DropDownInput<BasicDetailsFormFields>
          data={cityList}
          name="city"
          label="City*"
          control={control}
          register={register}
          errors={errors}
          disabled={disable}
        />
      </div>
      <div className={Styles.formAction}>
        <span></span>
        <Button variant="primary" onClick={handleSubmit(onSubmitForm)}>Now, Add your Resume</Button>
      </div>
    </form>
  )
}
export default BasicDetails;